import * as yup from "yup";

import {
  BackdropCircularProgress,
  EnhancedDropDownRHFWithLabel,
  EnhancedSnackbar,
  IResponse,
  IServerError,
  LabelPosition,
  SingleColumnLayout,
  StandardPanel,
  StandardSubmitFormButtonsToolbar,
  TopRowTwoColumnLayout,
} from "@websential/cosmic";
import { FormProvider, useForm } from "react-hook-form";
import {
  INITIAL_SNACKBAR_DATA,
  UPDATE_INVOICE_SCREEN_SLUG,
} from "../../../common/constants";
import React, { useEffect, useState } from "react";
import { clearSelectedINVOICE, setSelectedINVOICE } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AddPenaltiesOrDiscountTable } from "./AddPenaltiesOrDiscount/AddPenaltiesOrDiscountTable/AddPenaltiesOrDiscountTable";
import { Calendar } from "primereact/calendar";
import { Grid } from "@mui/material";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { ReportsService } from "../../../services/ReportsService";
import { UpdateInvoiceDetailsByRefNo } from "./UpdateInvoiceDetailsByRefNo";
import UpdateInvoideDataTable from "./UpdateInvoideDataTable";
import { format } from "date-fns";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IUpdateInvoice { }

const useUpdateInvoices = (refNo: string) =>
  useQuery({
    queryKey: ["update-invoice", refNo],
    queryFn: (data) => {
      return ReportsService.getUpdateInvoice(refNo);
    },
    refetchOnWindowFocus: false
  });

const useUpdateInvoicesDDL = () =>
  useQuery({
    queryKey: ["update-invoice-ddl"],
    queryFn: (data) => {
      return ReportsService.getUpdateInvoiceDDL();
    },
    refetchOnWindowFocus: false
  });

export let addPenaltiesFeildsPanelInitialData = [
  {
    id: "1",
    label: null,
    amount: null,
    type: null,
    taxable: false
  },
]
export const UpdateInvoice: React.FC<IUpdateInvoice> = () => {
  const dispatch = useDispatch();
  const refNo = useSelector((state: IAppState) => state.invoice.refNo);
  const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
  const [paymentDate, setPaymentDate] = useState<any>(undefined);
  const [paymentDatePlaceHolder, setPaymentDatePlaceHolder] =
    useState<any>(undefined);
  const [refundDate, setRefundDate] = useState<any>(undefined);
  const [responseData, setResponseData] = useState<any>(undefined);
  const [refundDatePlaceHolder, setRefundDatePlaceHolder] =
    useState<any>(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [paidAmountValue, setPaidAmountValue] = useState(0);
  const [refundAmountValue, setRefundAmountValue] = useState(0);
  const queryClient = useQueryClient();
  const [addPenaltiesOrDiscountUpdatedData, setAddPenaltiesOrDiscountUpdatedData] =
    useState(addPenaltiesFeildsPanelInitialData);
  const [addPenaltiesOrDiscountTableDataItems, setAddPenaltiesOrDiscountTableDataItems] =
    useState(addPenaltiesFeildsPanelInitialData);

  const { isPending: isLoadingInvoiceDetailDDL, data: invoiceRefNoDDL } =
    useUpdateInvoicesDDL();

  const { isPending: isLoadingInvoiceDetail, data: invoiceDetailByRefNo } =
    useUpdateInvoices(refNo);

  useEffect(() => {
    if (invoiceDetailByRefNo && invoiceDetailByRefNo.status === 200) {
      setResponseData(invoiceDetailByRefNo.data);
    }
  }, [invoiceDetailByRefNo]);

  let DEFAULT_VALUES = {};
  const T4SlipSetupValidationSchema = yup.object({
    refNo: yup.string().required('Ref. No. is required')
  });

  const formMethods = useForm<any>({
    resolver: yupResolver(T4SlipSetupValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });

  const { isPending: isSubmitting, mutate: submitInvoice } = useMutation({
    mutationFn: ReportsService.updateInvoice,

    onSuccess: (res: IServerError | IResponse | any) => {

      if (res.message) {
        setSnackbarData({
          open: true,
          message: res.message,
          severity: "error",
        });
      } else {
        setSnackbarData({
          open: true,
          message: "Data has been submitted successfully!",
          severity: "success",
        });
        queryClient.invalidateQueries({ queryKey: ["update-invoice"] });
      }
    },
    onError: (err: any) => {

      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        // message: "Something went wrong, try again later!",
        message: err.message,
        severity: "error",
      });
    },
  }
  );

  const onSubmit = (formData: any) => {

    const requestPayload = {
      refNo: refNo,
      invoiceNo: formData.invoiceNo && formData.invoiceNo,
      paymentStatus: formData.status,
      paidAmount: paidAmountValue,
      paymentDate:
        paymentDate && paymentDate.charAt(2) === "*"
          ? undefined
          : paymentDate !== "" || null
            ? paymentDate
            : undefined,
      refundAmount: refundAmountValue,
      refundDate:
        refundDate && refundDate.charAt(2) === "*"
          ? undefined
          : refundDate !== "" || null
            ? refundDate
            : undefined,
      notes: formData.notes !== "" ? formData.notes : undefined,
      invoiceAmountByUser: addPenaltiesOrDiscountUpdatedData.filter((x: any) => x.label !== null && x.label !== "")
    };
    console.log('requestPayload', requestPayload)
    submitInvoice(requestPayload);
  };

  const onResetClicked = () => {
    dispatch(clearSelectedINVOICE());
    setSnackbarData({
      open: true,
      message: "Form was reset successfully",
      severity: "success",
    });
    formMethods.reset();
    window.location.reload();
  };

  const onSnackbarClosed = (
    _event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const refNoDDL = [
    {
      label: "UPI00001",
      value: "UPI00001",
    },
    {
      label: "UPI00002",
      value: "UPI00002",
    },
  ];

  // format date to 2023-07-26
  const formatDate = (date: Date): string => {

    return format(date, "yyyy-MM-dd"); // Format the date as "yyyy-MM-dd"
  };

  const onPaymentDateChangeHandler = (selectedDate: any) => {
    setPaymentDate(formatDate(selectedDate.value as Date));
  };

  const onRefundDateChangeHandler = (selectedDate: any) => {
    setRefundDate(formatDate(selectedDate.value as Date));
  };

  const onRefNoChangeHandler = (ref: any) => {
    const refNumber = { refNo: ref.value };
    dispatch(setSelectedINVOICE(refNumber));
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    if (invoiceDetailByRefNo && invoiceDetailByRefNo.status === 200) {
      formMethods.setValue(
        "invoiceNo",
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.invoiceNo
      );
      formMethods.setValue(
        "refNo",
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.refNo
      );
      formMethods.setValue(
        "status",
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.paymentStatus
      );
      formMethods.setValue(
        "paidAmount",
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.paidAmount
      );
      formMethods.setValue(
        "refundAmount",
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.refundAmount
      );
      formMethods.setValue(
        "notes",
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.notes
      );
      setRefundAmountValue(
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.refundAmount
      );
      setPaidAmountValue(
        invoiceDetailByRefNo && invoiceDetailByRefNo.data.paidAmount
      );
      //paymentDate
      if (
        (invoiceDetailByRefNo &&
          invoiceDetailByRefNo.data.paymentDate !== null) ||
        undefined
      ) {
        if (
          invoiceDetailByRefNo &&
          invoiceDetailByRefNo.data.paymentDate.charAt(2) === "*"
        ) {
          formMethods.setValue(
            "paymentDate",
            invoiceDetailByRefNo && invoiceDetailByRefNo.data.paymentDate
          );
          setPaymentDate(
            invoiceDetailByRefNo && invoiceDetailByRefNo.data.paymentDate
          );
        } else {
          const defaultDate = new Date(
            invoiceDetailByRefNo && invoiceDetailByRefNo.data.paymentDate
          );
          setPaymentDate(formatDate(defaultDate as Date));
          formMethods.setValue("paymentDate", defaultDate);
        }
        setPaymentDatePlaceHolder(
          invoiceDetailByRefNo && invoiceDetailByRefNo.data.paymentDate
        );
      } else {
        formMethods.setValue("paymentDate", null);
      }
      //refundDate
      if (
        (invoiceDetailByRefNo &&
          invoiceDetailByRefNo.data.refundDate !== null) ||
        undefined
      ) {
        if (
          invoiceDetailByRefNo &&
          invoiceDetailByRefNo.data.refundDate.charAt(2) === "*"
        ) {
          formMethods.setValue(
            "refundDate",
            invoiceDetailByRefNo && invoiceDetailByRefNo.data.refundDate
          );
          setRefundDate(
            invoiceDetailByRefNo && invoiceDetailByRefNo.data.refundDate
          );
        } else {
          const defaultDate = new Date(
            invoiceDetailByRefNo && invoiceDetailByRefNo.data.refundDate
          );
          setRefundDate(formatDate(defaultDate as Date));
          formMethods.setValue("refundDate", defaultDate);
        }
        setRefundDatePlaceHolder(
          invoiceDetailByRefNo && invoiceDetailByRefNo.data.refundDate
        );
      } else {
        formMethods.setValue("refundDate", null);
      }

      if (invoiceDetailByRefNo.data.invoiceAmountByUser && invoiceDetailByRefNo.data.invoiceAmountByUser.length !== 0) {
        setAddPenaltiesOrDiscountTableDataItems(invoiceDetailByRefNo.data.invoiceAmountByUser);
        setAddPenaltiesOrDiscountUpdatedData(invoiceDetailByRefNo.data.invoiceAmountByUser);
      } else {
        setAddPenaltiesOrDiscountTableDataItems(addPenaltiesFeildsPanelInitialData);
        setAddPenaltiesOrDiscountUpdatedData(addPenaltiesFeildsPanelInitialData);
      }
    } else {
      if (invoiceDetailByRefNo) {
        setSnackbarData({
          open: true,
          message:
            invoiceDetailByRefNo &&
              invoiceDetailByRefNo.message !== undefined &&
              typeof (
                invoiceDetailByRefNo.message && invoiceDetailByRefNo.message
              ) !== "object"
              ? invoiceDetailByRefNo.message && invoiceDetailByRefNo.message
              : invoiceDetailByRefNo.message.message
                ? invoiceDetailByRefNo.message.message
                : "Something went wrong!",
          severity:
            invoiceDetailByRefNo.status === false
              ? "error"
              : invoiceDetailByRefNo.success === false
                ? "error"
                : "success",
        });
      }
    }
  }, [invoiceDetailByRefNo, formMethods.setValue, formMethods]);

  const onPaymentStatusChangeHandler = (event: any) => {

    if (event.value === true) {
      formMethods.setValue("paymentDate", new Date());
      setPaymentDate(formatDate(new Date() as Date));
    } else {
      formMethods.setValue("paymentDate", undefined);
      setPaymentDate(undefined);
    }
  };

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: "",
        entityId2: "",
        entityId3: "",
        screenName: UPDATE_INVOICE_SCREEN_SLUG,
        companyName: "",
        activityType: "activity_type=create&activity_type=updated",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, []);


  return (
    <Grid
      sx={{
        paddingBottom: "5rem",
        "& .MuiAppBar-root": { zIndex: 2, top: "65px" },
      }}
    >
      <BackdropCircularProgress
        open={
          isLoadingInvoiceDetail ||
          isLoading ||
          isSubmitting ||
          isLoadingInvoiceDetailDDL
        }
        testId={`UpdateInvoice-backdrop`}
      />
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
          <TopRowTwoColumnLayout
            topRowContent={
              <StandardPanel
                title="Update Invoice"
                testId={`UpdateInvoice`}
                leftSpacing={2}
                rightSpacing={2}
              >
                <EnhancedDropDownRHFWithLabel
                  selectName="refNo"
                  label="Load Invoice Ref. No."
                  labelPosition={LabelPosition.Left}
                  items={invoiceRefNoDDL ? invoiceRefNoDDL : []}
                  // selectedItem={selectedBillingProfile.id}
                  testId={"UpdateInvoice-refNo-list"}
                  // isLoading={isLoadingBillingProfileList}
                  onSelectionChangeHandler={onRefNoChangeHandler}
                />
              </StandardPanel>
            }
            leftColumnContent={
              <StandardPanel
                title="Update Invoice Details"
                testId={`UpdateInvoice Details`}
                leftSpacing={2}
                rightSpacing={2}
                topPadding={2}
              >
                <UpdateInvoiceDetailsByRefNo
                  formMethods={formMethods}
                  paymentDate={paymentDate && paymentDate}
                  paymentDatePlaceHolder={
                    paymentDatePlaceHolder && paymentDatePlaceHolder
                  }
                  onPaymentDateChangeHandler={onPaymentDateChangeHandler}
                  refundDatePlaceHolder={
                    refundDatePlaceHolder && refundDatePlaceHolder
                  }
                  onRefundDateChangeHandler={onRefundDateChangeHandler}
                  companyName={responseData && responseData.companyName}
                  clientId={responseData && responseData.clientId}
                  paidAmountValue={(value: any) => setPaidAmountValue(value)}
                  refundAmountValue={(value: any) =>
                    setRefundAmountValue(value)
                  }
                  onPaymentStatusChangeHandler={onPaymentStatusChangeHandler}
                />
              </StandardPanel>
            }
            rightColumnContent={
              <StandardPanel
                title={"Add/Subtract Transactions"}
                testId={"add-penalties-or-discount"}
                topPadding={2}
              >
                {/* <AddPenaltiesOrDiscountTable /> */}
                <AddPenaltiesOrDiscountTable
                  addPenaltiesOrDiscountTableUpdatedData={(data: any) =>
                    setAddPenaltiesOrDiscountUpdatedData(data)
                  }
                  addPenaltiesOrDiscountFieldsDataItems={
                    addPenaltiesOrDiscountTableDataItems
                  }
                //   columns={[
                // 	{ field: "label", headerName: "Label" },
                // 	{ field: "amount", headerName: "Amount" },
                // 	{ field: "type", headerName: "" },
                // 	{ field: "taxable", headerName: "" },
                // ]}
                />
              </StandardPanel>
            }
            toolbar={
              <StandardSubmitFormButtonsToolbar
                onResetClicked={onResetClicked}
                isSubmitting={false}
                testId="standard-form-submit-toolbar"
              />
            }
            testId="form-layout"
          />
        </form>
      </FormProvider>
      {/* <UpdateInvoideDataTable
        rows={[]}
        columns={[]}
        showIndexColumn={false}
        showChecboxColumn={false}
        showSettingColumn={false}
        // isLoading={isLoading}
      /> */}
      <EnhancedSnackbar
        message={snackbarData.message}
        onCloseHandler={onSnackbarClosed}
        severity={snackbarData.severity}
        testId={`UpdateInvoice-snackbar`}
        open={snackbarData.open}
      />
    </Grid>
  );
};
